import clsx from 'clsx';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import AddendumIcon from 'core/icons/addendumIcon';
import ToolTip from 'core/components/Tooltip';
import {
  PatientVisitDTO,
} from 'dtos';
import {
  visitNoteEventChannel,
} from 'pages/Dashboard/services/eventChannels';

type Props = {
  visitInfo: PatientVisitDTO;
};

export default function Addendum({ visitInfo }: Props) {
  return (
    <ToolTip title={visitInfo.isFinalized ? 'Open Addendum' : 'Visit Note is not finalized'}>
      <div className={clsx({ 'cursor-not-allowed': !visitInfo.isFinalized })}>
        <IconButton
          disabled={!visitInfo.isFinalized}
          onClick={(e) => {
            e.stopPropagation();
            visitNoteEventChannel.emit('onAddAddendum', {
              visitInfo,
            });
          }}
        >
          <AddendumIcon className="!w-4 !h-4" />
        </IconButton>
      </div>
    </ToolTip>
  );
}
